import React from 'react';
import { Typography } from '@mui/material';
import WorkoutEntryForm from '../components/WorkoutEntryForm';

const WorkoutsPage = () => {
    const today = new Date();
    const todayName = today.toLocaleDateString('en-US', { weekday: 'long'});
    return(
    <div>
        <Typography variant="h4" gutterBottom>
            My Workouts
        </Typography>
        <Typography variant="body1">
            Here is where your workouts will appear.
        </Typography>

        <Typography variant="h5" gutterBottom>
            Today's Workout
        </Typography>

        <WorkoutEntryForm selectDay={todayName} />
    </div>
    );
};

export default WorkoutsPage;